import React from 'react';
import moment from 'moment';
import '../css/dataTables.css';
import { CURRENCY, FORMAT_NUMBER } from '../libs/utils/Const';
 
const renderTableBody = (headers, data, action, checkbox, flagInvoices) => {
    let body = "";
    body = data.map((register, index) => {

        let fecha = new Date(register.TaxDate);
        fecha.setMinutes(fecha.getMinutes() + fecha.getTimezoneOffset());
        fecha = moment(fecha).format('DD-MM-YYYY');

        return (
            <tr key={index}>
                <td style={{ textAlign: "center", width: 100 }}>
                    <input type="checkbox" style={{ minWidth: '100%' }} id="cbox2" checked={!!checkbox.data.get(index)} disabled={register.selected || false}
                        onChange={() => checkbox.selectOne(index)} />
                </td>
                <td>{register.DocNum || ""}</td>
                <td style={{ textAlign: "center" }}>{register.ObjType.toString() === '13' ? register.DocSubType === '--' ? 'Factura' : 'Nota de Débito' : register.ObjType.toString() === '14' ? register.DocSubType === '--' ? 'Nota de Crédito' : '' : 'Factura Proveedores'}</td>
                <td>{fecha || ""}</td>
                <td style={{ textAlign: "center" }}>{register.Filler ?? ''}</td>
                <td style={{ textAlign: "center" }}>{register.ToWhsCode ?? ''}</td>
                <td style={{ textAlign: "right" }}>{CURRENCY + FORMAT_NUMBER.new(register.DocCur === 'SOL' ? (register.DocTotal - register.PaidToDate) : (register.DocTotalFC - register.PaidFC)) || ""}</td>
            </tr>
        )
    })

    return body;
};

const renderTable = (headers, data, action, checkbox, flagInvoices) => {
    let header = "";
    let body = "";

    if (headers.length !== 0) {
        header = <tr>
            <td className="sticky-header table-header-yellow ">
                {flagInvoices && <input type="checkbox" style={{ minWidth: '100%' }}
                    onChange={(event) => checkbox.selectAll(event.target.checked)} />}
            </td>
            <td className="sticky-header table-header-yellow ">{headers[0].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[1].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[2].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[3].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[4].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[5].title}</td>
        </tr>;
    }

    body = renderTableBody(headers, data, action, checkbox, flagInvoices);

    let table = "";

    table =
        <div className="table-wrapper-scroll-y my-custom-scrollbar">
            <table id="dataTableCreate" className="display" style={{ width: '100%' }}>
                <thead className="table-header">
                    {header}
                </thead>
                <tbody>
                    {body}
                </tbody>
            </table>
        </div>;

    return table;

};

export const renderTableTransfersModal = (headers, data, action, checkbox, flagInvoices) => {

    return renderTable(headers, data, action, checkbox, flagInvoices);

}
